
import Vue from 'vue';
import Component from 'vue-class-component';
import NodeFormMixin from '../forms/NodeFormMixin';

@Component({
  name: 'AccountSummary',
})
export default class AccountSummary extends NodeFormMixin { }
